import {
    request,
    requestPublic
} from './request.js'
// 上传图片
export function uploadImg(fd, type) {
    return request({
        // url: '/api3/Upload/ImgUpload?type=' + type,
        url: '/api2/FileAdmin/File/ImgUpload',
        method: 'post',
        data: fd
    })
}
//删除图片
export function removeImages(arr) {
    return request({
        // url: '/api3/Upload/RemoveImages',
        url: '/api2/FileAdmin/File/Delete',
        method: 'post',
        data:arr
    })
}

//上传文件
export function uploadFile(fd,type) {
    return request({
        // url: '/api3/Upload/FileUpload?type=' + type,
        url: '/api2/FileAdmin/File/FileUpload',
        method: 'post',
        data:fd
    })
}

// 上传图片
export function ImgUpload(fd) {
    return request({
        url: '/api2/FileAdmin/File/ImgUpload',
        method: 'post',
        data: fd
    })
}

//删除图片
export function DeleteImages(arr) {
    return request({
        url: '/api2/FileAdmin/File/Delete',
        method: 'post',
        data:arr
    })
}

//解码
export function SUB_URL_Decode(value) {
    try {
          return decodeURIComponent(value);
    } catch (err) {
          return value;
    }
}